<template>
	<q-page padding>
		<div class="row gutter-sm">
			<div class="col-12">
				<!-- :error="$v.slug.$error" @input="$v.slug.$touch"  -->
				<q-input v-model="slug" :float-label="$t('slug')" :disable="true" />
				<p class="text-weight-light q-caption">solicitar ao desenvolvimento o slug</p>
			</div>
			<div class="col-xs-12">
				<q-select
					v-model="badge_type"
					ref="group_training_type"
					:options="badge_types"
					:float-label="$t('badge_type')"
					@input="clearData"
				/>
			</div>
			<div class="col-xs-12 col-sm-12 ">
				<div class="row gutter-sm flex">
					<div class="col-xs-12 col-sm-6">
						<uploader
							content_type="images"
							@fileUploaded="imageUploaded"
							:multiple="false"
							:cropper="true"
							:aspect_ratio="1 / 1"
							:aspect_ratio_string="'1/1'"
						/>

						<p v-if="image" class="q-mt-md file-url">
							<q-icon name="fal fa-check" color="positive" />
							<a :href="image" target="_blank"> {{ $truncateLink(image) }}</a>
						</p>
					</div>
					<div class="col-xs-12 col-sm-6">
						<p class="caption">
							{{ $t('alt_image') }}
							<q-icon
								name="fal fa-question-circle"
								size="1.5rem"
								color="grey"
								class="q-ml-sm q-pb-sm"
							>
								<q-tooltip
									class="custom-tooltip"
									anchor="top left"
									self="bottom right"
								>
									{{ $t('alt_image_information_helper') }}
								</q-tooltip>
							</q-icon>
						</p>
						<div class="flex justify-between">
							<template v-for="lang in languages" class="row flex">
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'pt-br'">
									<q-input
										v-model="language_br"
										:float-label="$t(`${lang.name}`)"
										ref="language_br"
										:error="$v.language_br.$error"
										@input="$v.language_br.$touch"
									/>
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'en-us'">
									<q-input
										v-model="language_us"
										:float-label="$t(`${lang.name}`)"
										ref="language_us"
										:error="$v.language_us.$error"
										@input="$v.language_us.$touch"
									/>
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'es-es'">
									<q-input
										v-model="language_es"
										:float-label="$t(`${lang.name}`)"
										ref="language_es"
										:error="$v.language_es.$error"
										@input="$v.language_es.$touch"
									/>
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'fr-fr'">
									<q-input
										v-model="language_fr"
										:float-label="$t(`${lang.name}`)"
										ref="language_fr"
										:error="$v.language_fr.$error"
										@input="$v.language_fr.$touch"
									/>
								</q-field>
							</template>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12">
				<q-tabs v-model="tab" color="secondary" class="shadow-1">
					<q-tab
						slot="title"
						v-for="(l, index) in laguages"
						:key="`t-${index}`"
						:name="`tab-${l.id}`"
						:label="l.name"
					/>
					<q-tab-pane
						v-for="(l, index) in laguages"
						:key="`tp-${index}`"
						:name="`tab-${l.id}`"
					>
						<div class="row" v-if="getTitle">
							<div class="col-xs-12 col-sm-12">
								<div class="col-12">
									<q-input v-model="getTitle.title" :float-label="$t('title')" />
								</div>

								<div class="col-12">
									<q-input
										v-model="getTitle.description"
										:float-label="$t('description')"
									/>
								</div>
							</div>
						</div>
					</q-tab-pane>
				</q-tabs>
			</div>

			<div v-if="badge_type === 1" class="row gutter-sm q-mt-xs">
				<div class="col-xs-12 col-sm-12">
					<p class="caption">{{ $t('countries') }}</p>
					<div class="row gutter-sm">
						<div class="col-xs-12 col-sm-12">
							<q-checkbox
								v-model="all_countries"
								:val="true"
								:label="$t('select_all_countries')"
								@input="checkAllCountries()"
							/>
						</div>

						<div
							class="col-xs-12 col-sm-4"
							v-for="(item, index) in countries"
							:key="index"
							:class="getErrorClass($v.country.$error)"
						>
							<q-checkbox
								keep-color
								v-model="country"
								ref="country"
								:val="item.value"
								:label="item.label"
								:color="getErrorColor($v.country.$error)"
							/>
						</div>
					</div>
				</div>

				<div class="col-xs-12 col-sm-12">
					<p class="caption">{{ $t('areas') }}</p>
					<q-checkbox
						class="q-mb-sm"
						v-model="all_areas"
						:val="true"
						:label="$t('select_all_areas')"
						@input="checkAllAreas()"
					/>
					<q-select
						filter
						autofocus-filter
						v-model="area"
						ref="area"
						:options="areas"
						:error="$v.area.$error"
						multiple
						chips
					/>
				</div>

				<div class="col-xs-12 col-sm-12">
					<p class="caption">{{ $t('profiles') }}</p>
					<div class="row gutter-sm">
						<div class="col-xs-12 col-sm-12">
							<q-checkbox
								v-model="all_profiles"
								:val="true"
								:label="$t('all')"
								@input="checkAll()"
							/>
						</div>

						<div
							class="col-xs-12 col-sm-4"
							v-for="(item, index) in profiles"
							:key="index"
							:class="getErrorClass($v.profile.$error)"
						>
							<q-checkbox
								keep-color
								v-model="profile"
								ref="profile"
								:val="item.value"
								:label="item.label"
								:color="getErrorColor($v.profile.$error)"
							/>
						</div>
					</div>
				</div>

				<div class="col-xs-12 col-sm-12">
					<q-select
						v-model="user_group"
						ref="user_group"
						:options="user_groups"
						:float-label="$t('groups')"
						:error="$v.user_group.$error"
						@input="$v.user_group.$touch"
						multiple
						chips
					/>
				</div>
			</div>

			<div class="col-xs-12 col-sm-12 q-my-md	">
				<q-checkbox
					v-model="show_on_profile"
					:val="true"
					:label="$t('show_on_profile')"
					@input="checkAll()"
				/>
			</div>

			<div class="col-12">
				<p class="caption">{{ $t('status') }}</p>
				<q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses" />
			</div>

		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="$router.push({ name: 'admin_badges' })"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
				/>
			</div>
		</div>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Uploader from 'components/Uploader'
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'

export default {
	i18nOptions: { namespaces: ['common', 'admin'] },

	components: {
		uploader: Uploader,
	},

	data() {
		return {
			language_br: '',
			language_us: '',
			language_es: '',
			language_fr: '',
			all_areas: false,
			all_countries: false,
			tab: 'tab-1',
			description: '',
			slug: '',
			status: 1,
			title: '',
			titles: [],
			image: '',
			all_profiles: false,
			profile: [],
			area: [],
			country: [],
			user_group: [],
			statuses: [
				{ label: this.$t('published'), value: 1 },
				{ label: this.$t('unpublished'), value: 2 },
			],
			badge_type: 1,
			badge_types: [
				{ label: this.$t('custom_badge'), value: 1 },
				{ label: this.$t('default_badge'), value: 2 },
			],
			show_on_profile: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			areas: 'registration_lists/country_areas',
			countries: 'registration_lists/countries',
			laguages: 'params/languages',
			profiles: 'registration_lists/profiles',
			user_groups: 'registration_lists/group_users',
			languages: 'params/languages',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getColorStatus() {
			if (this.status == 1) return 'positive'
			else return 'negative'
		},

		getTitle: {
			get() {
				let language_id = this.tab.split('-')[1]
				let obj = this.titles.find((obj) => {
					return obj.language == language_id
				})
				if (obj) {
					return obj
				} else {
					return { title: '', description: '' }
				}
			},
			set(newVal) {
				console.log(newVal)
				let language_id = this.tab.split('-')[1]
				let obj = this.titles.find((obj) => {
					return obj.language == language_id
				})
				if (obj) obj
			},
		},
	},

	methods: {
		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(`admin_badges/badges/${this.$route.params.id}/`, this.getHeader)
				.then((response) => {
					let image = ''
					if (response.data.badge_images.length > 0) {
						image = response.data.badge_images[0]
					}

					this.badge_type = response.data.badge_type
					this.titles = response.data.badge_languages
					this.description = response.data.description
					this.slug = response.data.slug
					this.status = response.data.status
					this.title = response.data.title
					this.profile = response.data.profiles
					this.area = response.data.areas
					this.country = response.data.countries
					this.user_group = response.data.user_groups
					this.show_on_profile = response.data.show_on_profile
					this.image = image
					const altTextMap = {}
					response.data.badge_image_alt_texts.forEach((altTextObj) => {
						altTextMap[altTextObj.language] = altTextObj.alt_text
					})
					this.language_br = altTextMap['pt-br'] || ''
					this.language_us = altTextMap['en-us'] || ''
					this.language_es = altTextMap['es-es'] || ''
					this.language_fr = altTextMap['fr-fr'] || ''

					this.objTitle()
					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
				})
		},

		saveData() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()

				let data = {
					badge_type: this.badge_type,
					title: this.title,
					description: this.description,
					image: this.image,
					status: this.status,
					badge_languages: [],
					badge_image_alt_texts: {
						'pt-br': this.language_br ? this.language_br : '',
						'en-us': this.language_us ? this.language_us : '',
						'es-es': this.language_es ? this.language_es : '',
						'fr-fr': this.language_fr ? this.language_fr : '',
					},
					show_on_profile: this.show_on_profile,
				}

				if (this.badge_type === 1) {
					data.areas = this.area
					data.profiles = this.profile
					data.user_groups = this.user_group
					data.countries = this.country
				}

				this.titles.map((t) => {
					if (t.title) data.badge_languages.push(t)
				})

				if (this.$route.params.id == 0) {
					this.$axios
						.post(`admin_badges/badges/`, data, this.getHeader)
						.then(() => {
							this.$q.notify({
								message: this.$t('badge_add_success'),
								type: 'positive',
								icon: 'fal fa-save',
							})

							this.$router.push({ name: 'admin_badges' })
						})
						.catch((e) => {
							this.$q.notify({
								message: this.$t('badge_add_error'),
								type: 'negative',
								icon: 'fal fa-ban',
							})

							console.log(e)
						})
						.finally(() => {
							this.$q.loading.hide()
						})
				} else {
					this.$axios
						.put(`admin_badges/badges/${this.$route.params.id}/`, data, this.getHeader)
						.then(() => {
							this.$q.notify({
								message: this.$t('badge_edit_success'),
								type: 'positive',
								icon: 'fal fa-save',
							})

							this.$router.push({ name: 'admin_badges' })
						})
						.catch((e) => {
							this.$q.notify({
								message: this.$t('badge_edit_error'),
								type: 'negative',
								icon: 'fal fa-ban',
							})

							console.log(e)
						})
						.finally(() => {
							this.$q.loading.hide()
						})
				}
			}
		},

		imageUploaded(url) {
			this.image = url
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		objTitle() {
			if (this.titles.length !== this.laguages) {
				this.laguages.map((l) => {
					let obj = this.titles.find((obj) => {
						return obj.language == l.id
					})
					if (!obj) this.titles.push({ title: '', description: '', language: l.id })
				})
			}
		},

		checkAllAreas() {
			if (this.all_areas) {
				this.area = this.areas.map((e) => e.value)
			} else this.area = []
		},

		checkAllCountries() {
			if (this.all_countries) {
				this.country = this.countries.map((e) => e.value)
			} else this.country = []
		},

		checkAll() {
			if (this.all_profiles) {
				this.profile = this.profiles.map((e) => e.value)
			} else this.profile = []
		},

		getErrorColor(state) {
			if (state) return 'negative'
			else return ''
		},

		getErrorClass(state) {
			if (state) return 'checkbox-error'
			else return ''
		},

		clearData() {
			this.area = []
			this.profile = []
			this.user_group = []
			this.country = []
		},
	},

	created() {
		if (this.$route.params.id != 0) this.fetchData()
		else this.objTitle()
	},

	validations() {
		return {
			// slug: { required },
			language_br: { maxLength: maxLength(256) },
			language_us: { maxLength: maxLength(256) },
			language_es: { maxLength: maxLength(256) },
			language_fr: { maxLength: maxLength(256) },

			area: {
				requiredIf: requiredIf(() => {
					if (this.badge_type === 2) return false

					if (this.area.length > 0 || this.user_group.length == 0) {
						return true
					} else {
						return false
					}
				}),
			},
			country: {
				requiredIf: requiredIf(() => {
					if (this.badge_type === 2) return false

					if (this.profile.length == 0 && this.country.length == 0) {
						if (
							this.profile.length == 0 &&
							this.area.length == 0 &&
							this.user_group.length == 0 &&
							this.country.length == 0
						)
							return true
						else return false
					} else {
						return true
					}
				}),
			},
			profile: {
				requiredIf: requiredIf(() => {
					if (this.badge_type === 2) return false

					if (this.user_group.length  == 0 || this.area.length > 0) {
						return true
					}
				}),
			},
			user_group: {
				requiredIf: requiredIf(() => {
					if (this.badge_type === 2) return false

					if (
						this.profile.length == 0 &&
						this.area.length == 0 &&
						this.user_group.length == 0 &&
						this.country.length == 0
					) {
						return true
					} else {
						return false
					}
				}),
			},
		}
	},
}
</script>

<style lang="stylus" scoped>
@import '~variables'

.file-url
    a
        text-decoration none
        color black
</style>
